export default __webpack_public_path__ + "static/UniversLTStd-Bold-2a68f58a04381a2c7eaba589e9f8e9bf.ttf";